import React, { useContext } from 'react'
import { IdentityContext } from '#src/containers/Identity'
import { format } from 'date-fns'
import styles from './styles.css'

interface TitleProps {
  title: React.ReactNode
  subTitle?: React.ReactNode
  sellableRatingQueueLength: number
}

const Title: React.SFC<TitleProps> = ({ title, subTitle, sellableRatingQueueLength }) => {
  const { myself } = useContext(IdentityContext)

  return (
    <div className={styles.title}>
      {myself &&
        myself.user.mostRecentLead && (
          <div className={styles.dateLine}>
            Updated {format(myself.user.mostRecentLead.createdAt, 'M/d/YY')} &bull;{' '}
            {sellableRatingQueueLength} recommendations
          </div>
        )}
      <div className={styles.header}>{title}</div>

      <div className={styles.body}>
        {subTitle
          ? subTitle
          : "We've prepared some recommendations for you based on your preferences.  Let your expert know which you like and dislike so they can help narrow your options."}
      </div>
    </div>
  )
}

export default Title
